<template>
    <div class="body-inner">
        <!-- Section -->
        <section class="fullscreen" data-bg-parallax="images/store-bg.jpg">
            <div class="container">
                <div>
                    <div class="text-center m-b-30">
                        <router-link to="/" class="logo">
                            <img :src="logo" alt="ETC">
                        </router-link>
                        <h1 class="display-3">Registrar cuenta</h1>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 center p-40 background-white b-r-6">
                            <vue-form :state="formstate" @submit.prevent="create()" class="form-transparent-grey">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <h3>Registrar nueva cuenta</h3>
                                        <p>Por favor complete los campos</p>
                                    </div>
                                    <div class="col-lg-12 form-group">
                                        <validate tag="div">
                                            <label class="sr-only">Nombre(s)</label>
                                            <input type="text" v-model="model.nombre" placeholder="* Nombre(s)" class="form-control" required name="nombres" id="nombres">
                                            <field-messages name="nombres" show="$invalid && $submitted" class="text-danger">
                                                <div slot="required">El nombre es requerido</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                    <div class="col-lg-12 form-group">
                                        <validate tag="div">
                                            <label class="sr-only">Apellido(s)</label>
                                            <input type="text" v-model="model.apellidos" placeholder="* Apellido(s)" class="form-control" required name="apellidos" id="apellidos">
                                            <field-messages name="apellidos" show="$invalid && $submitted" class="text-danger">
                                                <div slot="required">Los apellidos son requeridos</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                    <div class="col-lg-12 form-group">
                                        <validate tag="div">
                                            <label class="sr-only">Correo electrónico</label>
                                            <input type="email" v-model="model.email" placeholder="* Correo electrónico" class="form-control" required name="email" id="email">
                                            <field-messages name="email" show="$invalid && $submitted" class="text-danger">
                                                <div slot="required">El correo electrónico es requerido</div>
                                                <div slot="email">El correo electrónico no es válido</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                    <div class="col-lg-12 form-group">
                                        <validate tag="div">
                                            <label class="sr-only">Contraseña</label>
                                            <input type="password" v-model="model.password" placeholder="* Contraseña" class="form-control" required name="password" id="password" minlength="8">
                                            <field-messages name="password" show="$invalid && $submitted" class="text-danger">
                                                <div slot="required">La contraseña es requerida</div>
                                            <div slot="minlength">La contraseña debe de tener mínimo 8 caracteres</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                    <div class="col-lg-12 form-group">
                                        <validate tag="div">
                                            <label class="sr-only">Teléfono</label>
                                            <input type="text" v-model="model.telefono" placeholder="Teléfono" class="form-control" name="telefono" id="telefono">
                                        </validate>
                                    </div>
                                    <div class="col-lg-12 form-group">
                                        <validate tag="div">
                                            <multiselect
                                                v-model="model.id_cliente"
                                                :options="clients"
                                                track-by="id"
                                                label="nombre"
                                                id="id_cliente"
                                                name="id_cliente"
                                                placeholder="Seleccione una escuela o institución" required>
                                            </multiselect>
                                            <field-messages name="id_cliente" show="$invalid && $submitted" class="text-danger">
                                                <div slot="required">Este campo es requerido</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                    <div class="col-lg-12 form-group">
                                        <button class="btn" type="submit">Registrar cuenta </button>
                                    </div>
                                </div>
                            </vue-form>
                            <p class="small">Ya tengo cuenta <router-link to="/login">Ingresar</router-link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <footer id="footer">
            <div class="copyright-content">
                <div class="container">
                    <div class="copyright-text text-center">&copy; 2025 <a href="https://etciberoamerica.com/" target="_blank" rel="noopener">ETC IBEROAMÉRICA.</a> </div>
                </div>
            </div>
        </footer>
    </div>
    
</template>

<script>
/* eslint-disable */
import options from "../validations/validations.js";
Vue.use(VueForm, options);
export default {
    name: 'Registro',
    components: {

    },
    data() {
        return {
            formstate: {},
            clients: [],
            model: {
                nombre: '',
                apellidos: '',
                email: '',
                password: '',
                id_pais: '',
                id_idioma: '',
                id_estado: '',
                id_ciudad: '',
                id_zona_horaria: '',
                fecha_nacimiento: '',
                tipo_usuario: {id: '4'},
                telefono: '',
                tipo_usuario_pro: 1,
                id_cliente: {id: 0, nombre: 'Sin escuela o institución'}
            },
            hostname: '',
            logo: 'images/logo-etc.png'
        }
    },

    methods: {
        async create() {
            if (this.formstate.$invalid) {
                return;
            } else {
                await this.register('api/usuarios', this.model, '/login', '', null, 0, 1, null)
            }
        }
    },
    async mounted() {
        const script = document.createElement('script')
        script.src = '/js/functions.js'
        script.id = 'functionScript'
        document.body.appendChild(script)

        this.hostname = hostname

        if(this.hostname == 'storebpo.etciberoamerica.com')
            this.logo = 'images/bpo-login-logo.png'
        if(this.hostname == 'store-conalepon.etciberoamerica.com')
            this.logo = 'images/conalep-logo.png'        

        //Cargamos a los clientes
        this.openLoading()
        await this.getClients()
        Swal.close()
    },
    beforeDestroy() {
        const scriptElem = document.getElementById('functionScript'); 
        scriptElem.remove()
    }
}
</script>
